import ControlBarButton from '@3.0/Buttons/ControlBarButtons/ControlBarButton';
import { BoltOutlined, Cancel } from '@mui/icons-material';
import cn from 'utils/cn';

interface IngestionButtonProps {
  isIngestionRunning: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

function FullIngestionButton({
  isIngestionRunning,
  onClick,
  disabled = false,
}: IngestionButtonProps) {
  return (
    <ControlBarButton
      onClick={onClick}
      data-testid="ingestion-button"
      className={cn('tw:h-10', isIngestionRunning && 'tw:bg-status-alert/10 tw:shrink-0')}
      disabled={disabled}
    >
      {isIngestionRunning ? (
        <span className="tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-1 tw:shrink-0">
          <Cancel style={{ width: 16, height: 16 }} />
          <span className="tw:text-sm tw:font-normal">Stop</span>
        </span>
      ) : (
        <span className="tw:flex tw:flex-row tw:shrink-0 tw:justify-center tw:items-center tw:gap-1">
          <BoltOutlined style={{ width: 16, height: 16 }} />
          <span className="tw:text-sm tw:font-normal">Start </span>
        </span>
      )}
    </ControlBarButton>
  );
}

export default FullIngestionButton;
